/* import __COLOCATED_TEMPLATE__ from './application-deadline.hbs'; */
import Component from '@glimmer/component';
import { inject as service } from '@ember/service';

const EXPIRED = -1;
const ABOUT_TO_EXPIRE = 0;
const TIME_REMAINS = 1;

const DEADLINE_WARNING_MS = 259200000;

class PostingChipApplicationDeadlineComponent extends Component {
  @service moment;

  get deadlineEnum() {
    const momentService = this.moment;
    const { deadline } = this.args.assignment;

    // get the current date
    const currentDate = momentService.moment();

    // take diff in ms
    const msDifference = momentService.moment(deadline).diff(currentDate);

    if (msDifference <= 0) return EXPIRED;

    // within warning period or past deadline
    return msDifference > DEADLINE_WARNING_MS
      ? TIME_REMAINS
      : ABOUT_TO_EXPIRE;
  }

  get deadlineLabel() {
    if (this.deadlineEnum === EXPIRED) {
      return 'Expired';
    }

    const { deadline } = this.args.assignment;

    return `Expires in ${this.moment.moment(deadline).fromNow()}`;
  }
}

export default PostingChipApplicationDeadlineComponent;
